var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"root",staticClass:"barcode d-inline-block",style:(`height: ${_vm.height || '3em'};`)},_vm._l((_vm.widths),function(width,index){return _c('div',{class:'w-' + width + ' ' + (index % 2 === 0 ? 'filled' : '')})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }